// extracted by mini-css-extract-plugin
module.exports = {"appWrapper":"App_appWrapper__2Sagd","app":"App_app__2RMLa","webAppExpanded":"App_webAppExpanded__19QV4","webAppCollapsed":"App_webAppCollapsed__2WDNT"};